import { useSelector } from 'react-redux'

import { Images } from '~/assets'
import { Loading } from '~/components'

import Styled from './dashboard-vessel-traffic-information.styled'
import useHooks from './dashboard-vessel-traffic-information.hooks'

import { AutoStepScroll, VesselTrafficCard, VesselTrafficLegend } from './components'

import DashboardEmpty from '../dashboard-empty'
import { DropdownLocSide } from '../dashboard-dropdown.container'

const DashboardVesselTrafficInformation = () => {
  const { data, methods } = useHooks()

  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  return (
    <Styled.Main>
      <Styled.Section>
        <Styled.SectionTitle>VESSEL TRAFFIC INFORMATION</Styled.SectionTitle>

        <Styled.DropdownContainer>
          <DropdownLocSide
            location={Location}
            position='relative'
            dataList={UserLocations}
            setLocation={methods.handleSetLocation}
          />
          <Styled.CurrentDateContainer>
            <Styled.CalendarIcon src={Images.SmallCalendarIcon} alt='small-calendar-icon' />
            <Styled.CurrentDateText>{data.currentDate}</Styled.CurrentDateText>
          </Styled.CurrentDateContainer>
        </Styled.DropdownContainer>
      </Styled.Section>

      {data.isLoading && (
        <Styled.Main>
          <Loading />
        </Styled.Main>
      )}

      {!data.isLoading && data.dataOngoingVessel.length === 0 && data.dataNextPlan.length === 0 && (
        <DashboardEmpty title='No vessel traffic is currently available for display.' />
      )}

      {!data.isLoading && (data.dataOngoingVessel.length > 0 || data.dataNextPlan.length > 0) && (
        <>
          <Styled.DashboardContainer>
            {/* Ongoing Vessel Section */}
            <Styled.DashboardSection id='dasbboard-traffic-information-ongoing-vessel'>
              <Styled.TrafficTitle>Ongoing Vessel</Styled.TrafficTitle>
              <AutoStepScroll mode='smooth' scrollSpeed={0.25} length={data.dataOngoingVessel.length}>
                {data.dataOngoingVessel.map((item) => (
                  <VesselTrafficCard key={item.id} data={item} type='ongoing_vessel' />
                ))}
              </AutoStepScroll>
            </Styled.DashboardSection>

            {/* Next Plan Section */}
            <Styled.DashboardSection id='dasbboard-traffic-information-next-plan'>
              <Styled.TrafficTitle>Next Plan</Styled.TrafficTitle>
              <AutoStepScroll mode='smooth' scrollSpeed={0.25} length={data.dataNextPlan.length}>
                {data.dataNextPlan.map((item) => (
                  <VesselTrafficCard key={item.id} data={item} type='next_plan' />
                ))}
              </AutoStepScroll>
            </Styled.DashboardSection>
          </Styled.DashboardContainer>
          <VesselTrafficLegend />
        </>
      )}
    </Styled.Main>
  )
}

export default DashboardVesselTrafficInformation

DashboardVesselTrafficInformation.propTypes = {}